// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";

export interface INewGeneratedReport {
    report_url?: string;
}

interface ILastReportRespnse {
    last_report: IReport,
    is_new_generating: boolean
}

export interface IReport {
    id: number,
    user_id: number,
    job_id: number | null,
    file_path: string,
    type: string,
    created_at: string,
    updated_at: string
}

export type IReportFiltersType = { [key: string]: string };

export enum REPORT_TYPES {
    BANK_REFUNDS = 'bank_refunds',
    CREDITS = 'credits',
    TRANSACTIONS = 'transactions',
    SHIPMENT = 'shipments',
    BILLING = 'billing-history',
    RETURNS = 'returns',
    TRACKING = 'tracking',
    SHIPMENT_NEW = 'shipments-new',
    WALLET = 'wallet',
}

@injectable()
class ReportService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async generateReport(type: REPORT_TYPES, filters?: IReportFiltersType): Promise<INewGeneratedReport> {
        const res = await this.httpService.post<IApiResponse<INewGeneratedReport>>(`/rms-api/report`, {
            type,
            filters
        });
        return res.payload;
    }

    async lastReport(type: REPORT_TYPES): Promise<ILastReportRespnse> {
        const res = await this.httpService.get<IApiResponse<ILastReportRespnse>>(`/rms-api/report/last/${type}`);
        return res.payload;
    }
}

export default ReportService;
